/**
 * @generated SignedSource<<52cdd62d3aa382140716ad08efa0ca65>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RemoveAdminSystemRolesInput = {
  adminId: string;
  applicationId?: string | null | undefined;
  roleIds?: ReadonlyArray<string> | null | undefined;
  roleNames?: ReadonlyArray<string> | null | undefined;
  systemId: string;
};
export type useAdminMutationsRemoveSystemRolesMutation$variables = {
  input: RemoveAdminSystemRolesInput;
};
export type useAdminMutationsRemoveSystemRolesMutation$data = {
  readonly removeAdminSystemRoles: ReadonlyArray<{
    readonly id: string;
    readonly role: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly roleId: string;
  }>;
};
export type useAdminMutationsRemoveSystemRolesMutation = {
  response: useAdminMutationsRemoveSystemRolesMutation$data;
  variables: useAdminMutationsRemoveSystemRolesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AdminSystemRole",
    "kind": "LinkedField",
    "name": "removeAdminSystemRoles",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "roleId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Role",
        "kind": "LinkedField",
        "name": "role",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAdminMutationsRemoveSystemRolesMutation",
    "selections": (v2/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAdminMutationsRemoveSystemRolesMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "a6fbc1405df9586549e2e5a74a9b0457",
    "id": null,
    "metadata": {},
    "name": "useAdminMutationsRemoveSystemRolesMutation",
    "operationKind": "mutation",
    "text": "mutation useAdminMutationsRemoveSystemRolesMutation(\n  $input: RemoveAdminSystemRolesInput!\n) {\n  removeAdminSystemRoles(input: $input) {\n    id\n    roleId\n    role {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "566d58951eeac94e2acd855a8df6af67";

export default node;
